<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-list" class="q-mb-sm" /> {{ $t('redeems') }}
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="request_redeem" :label="$t('request_redeem')" />
            <q-tab slot="title" name="sales_history" :label="$t('sales_history')" />
            <q-tab slot="title" name="photo_upload_history" :label="$t('photo_upload_history')" />
            <q-tab slot="title" name="redeem_history" :label="$t('redeem_history')" />

            <q-tab-pane name="request_redeem">
                <request-redeem />
            </q-tab-pane>

            <q-tab-pane name="sales_history">
                <sales-history />
            </q-tab-pane>

            <q-tab-pane name="photo_upload_history" keep-alive>
               <photo-upload-history />
            </q-tab-pane>

            <q-tab-pane name="redeem_history">
                <redeem-history />
            </q-tab-pane>
        </q-tabs>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'reward_orders' })" />
            </div>
        </div>
    </q-page>
</template>

<script>
import RequestRedeem from 'components/admin/redeems/RequestRedeem'
import SalesHistory from 'components/admin/redeems/SalesHistory'
import RedeemHistory from 'components/admin/redeems/RedeemHistory'
import PhotoUploadHistory from 'components/admin/rewards/PhotoUploadHistory'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "profile", "training", "admin", "rewards" ] },

    components: {
        'request-redeem': RequestRedeem,
        'sales-history': SalesHistory,
        'redeem-history': RedeemHistory,
        'photo-upload-history': PhotoUploadHistory
    },

    data() {
        return {
            tab: 'request_redeem',
        }
    },

    methods: {
        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },
    },

    created() {

    }
}
</script>

<style>

</style>
